
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const AreaInfo = () => {
  const [error, setError] = useState(null);
  const [selectedArea, setSelectedArea] = useState("Select a Field First");
  const [coordinates, setCoordinates] = useState([]);
  const [selfieldName , setSelFieldName] = useState("select field ")
  const { t } = useTranslation();
  // Fetch data from localStorage on component mount
  useEffect(() => {
    const selRes = localStorage.getItem("data");
    if (selRes) {
      try {
        const selResJson = JSON.parse(selRes);
        const { coordinates, area, fieldName } = selResJson;

        // If valid data, set it into state
        if (coordinates && area && fieldName) {
          setSelFieldName(fieldName)
          setCoordinates(coordinates);
          setSelectedArea(area);
        }
      } catch (err) {
        console.error("Error parsing localStorage data:", err);
      }
    }
  }, []);

  // Fetch field data from Firestore
  // const getFieldData = async () => {
  //   try {
  //     const auth = getAuth();
  //     const user = auth.currentUser;

  //     if (user) {
  //       const db = getFirestore();
  //       const fieldsCollectionRef = collection(db, `users/${user.uid}/fields`);
  //       const querySnapshot = await getDocs(fieldsCollectionRef);

  //       const fields = querySnapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data(),
  //       }));

  //       setResults(fields);
      
  //     } else {
  //       throw new Error("User must be authenticated to retrieve field data.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     setError(error.message);
  //   }
  // };

  // Handle field selection
  // const handleSelection = (event) => {
  //   const fieldId = event.target.value;
  //   const selectedField = results.find((field) => field.fieldName === fieldId);
  //   // console.log("selectedfield: ",selectedField)
  //   if (selectedField) {
  //     const { area, coordinates, fieldName } = selectedField;

  //     // Save selected field data in localStorage
  //     localStorage.setItem(
  //       "data",
  //       JSON.stringify({ coordinates, area, fieldName })
  //     );

  //     setSelectedArea(area);

  //     // Convert coordinates if necessary
  //     const convertCoordinates = (coords) => {
  //       return coords.map((coord) => [coord.longitude, coord.latitude]);
  //     };

  //     const output = convertCoordinates(coordinates);
  //     setCoordinates(output);
  //     polygon({ output, fieldName }); // Pass the data to the parent component
  //   }
  // };

  return (
    <div className="w-full">
      <div>
        {error &&  (
          <p className="my-2 text-sm md:text-[16px] text-red-500">
            {t("Error")}: {error}
          </p>
        )}
        <div
          className="w-full rounded-md p-3 text-center bg-[#3b82f6] text-white text-[16px] font-medium"
        >
           {t(selfieldName.split('-')[0])}
      </div>
      </div>
      <div className="w-full mt-2 bg-slate-200 text-black rounded-lg h-12 flex items-center px-2">
        <div className="text-[16px] font-medium">
          {t("Size") + `: ${selectedArea} ` + t("acres")}
        </div>
      </div>
    </div>
  );
};

export default AreaInfo;